// src/store/modules/teams.js
import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";

export default {
  state: {
    teams: [],
    saveTeamsResponse: null,
    loadingTeams: false,
  },

  mutations: {
    setTeams(state, payload) {
      state.teams = payload;
    },
    setSaveTeamsResponse(state, payload) {
      state.saveTeamsResponse = payload;
    },
    setLoadingTeams(state, payload) {
      state.loadingTeams = payload;
    },
  },

  actions: {
    async fetchTeams({ commit }, { personId, locationId }) {
      commit("setLoadingTeams", true);
      try {
        const response = await api.get(`/activity-workgroup-teams?person_id=${personId}&location_id=${locationId}`);
        const teams = response.data?.data || response.data;
        commit("setTeams", teams);
        return teams;
      } catch (error) {
        handleApiError(error, "Failed to fetch teams");
        throw error;
      } finally {
        commit("setLoadingTeams", false);
      }
    },

    async saveTeams({ commit }, { personId, locationId, teamsArray }) {
      try {
        const response = await api.post("/manageuserajax", {
          cmd: "saveteams",
          personid: personId,
          locationid: locationId,
          teamsarray: teamsArray,
        });
        commit("setSaveTeamsResponse", response.data);
        return response.data;
      } catch (error) {
        handleApiError(error, "Failed to save teams");
        throw error;
      }
    },
  },

  getters: {
    getTeams: (state) => state.teams,
    getSaveTeamsResponse: (state) => state.saveTeamsResponse,
    isTeamsLoading: (state) => state.loadingTeams,
  },
};